import { useState } from 'react';
import { ContentWithLegendCollapseProps } from './ContentWithLegendCollapse';
import { ContentWithLegendCollapsibleLegendProps } from './model/content-with-legend-model';

/**
 * Hook that manages internal state for the collapsible legend feature.
 */
export const useCollapsibleLegend = ({
  defaultIsCollapsed = false,
  title,
  show = false,
}: ContentWithLegendCollapsibleLegendProps = {}): ContentWithLegendCollapseProps => {
  const [isCollapsed, setIsCollapsed] = useState(defaultIsCollapsed);

  const toggleCollapsed = () => {
    setIsCollapsed((prevCollapsed) => !prevCollapsed);
  };

  return {
    title,
    isCollapsed: isCollapsed,
    toggleCollapsed,
    show,
  };
};
